import React, { useState } from "react";
import iPhone13 from "../assets/images/phone/iPhone13.webp";
import iPhone14 from "../assets/images/phone/iPhone_14_Pro_White.webp";
import GalaxyA53 from "../assets/images/phone/GalaxyA53.svg";
import GalaxyA16 from "../assets/images/phone/SamsungGalaxyA16_5G.svg";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";

const AppContext = React.createContext();
export const AppProvider = ({ children }) => {
  //Variables
  const baseUrl = "https://admin.fixtechexperts.co.uk";

  const apiKey = "AIzaSyByUuqn3kBeQwMtWYgbXtaDJtgZouIxtdA";
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });

  const navigate = useNavigate();

  const mobiles = [
    { id: 1, name: "Apple iPhone 13 Pro", price: "750", img: iPhone13 },
    {
      id: 2,
      name: "Apple iPhone 14 Pro Refurbished ",
      price: "445.00",
      img: iPhone14,
    },
    { id: 3, name: "Samsung Galaxy A53 5G", price: "750", img: GalaxyA53 },
    { id: 4, name: "Samsung Galaxy A16 5G", price: "750", img: GalaxyA16 },
  ];
  const whyChooseUs = [
    {
      title: "High-Quality Products",
      description:
        "Our products are crafted with care and precision, ensuring that you receive only the best. We use top-tier materials and follow strict quality control procedures to guarantee satisfaction.",
      icon: "AiFillProduct",
    },
    {
      title: "Fast & Reliable Service",
      description:
        "We value your time. Our team works efficiently to deliver your orders on time, every time. Enjoy a seamless shopping experience with quick processing and delivery.",
      icon: "MdMiscellaneousServices",
    },
    {
      title: "Affordable Pricing",
      description:
        "We believe in offering great value. Our products are competitively priced, ensuring that you get the best deal without compromising on quality.",
      icon: "IoPricetags",
    },
    {
      title: "Customer Satisfaction Guaranteed",
      description:
        "Your satisfaction is our priority. We are committed to providing excellent customer support, and we’ll go the extra mile to ensure you're happy with your purchase.",
      icon: "MdOutlineSentimentSatisfiedAlt",
    },
  ];

  const repairingTypes = [
    {
      title: "Mobile Phones",
      description:
        "Our products are crafted with care and precision, ensuring that you receive only the best. We use top-tier materials and follow strict quality control procedures to guarantee satisfaction.",
      icon: "HiOutlineDevicePhoneMobile",
      color: ["#ff8a08", "#fc9915", "#ffa423"],
    },
    {
      title: "Computer & Laptops",
      description:
        "We value your time. Our team works efficiently to deliver your orders on time, every time. Enjoy a seamless shopping experience with quick processing and delivery.",
      icon: "FaLaptop",
      color: ["#47a249", "#59b15c", "#64b867"],
    },
    {
      title: "Tablets & Ipads",
      description:
        "We believe in offering great value. Our products are competitively priced, ensuring that you get the best deal without compromising on quality.",
      icon: "MdTabletMac",
      color: ["#e43c35", "#ea4947", "#ef514d"],
    },
    {
      title: "Game Consoles",
      description:
        "Your satisfaction is our priority. We are committed to providing excellent customer support, and we’ll go the extra mile to ensure you're happy with your purchase.",
      icon: "GiConsoleController",
      color: ["#15adc5", "#19bbcf", "#24c4d9"],
    },
  ];

  //States (getters)
  const [selectedVehicle, setSelectedVehicle] = useState("");
  const [currentAddress, setCurrentAddress] = useState("");
  const [currentRegion, setCurrentRegion] = useState({});
  const [isPickupLocation, setIsPickupLocation] = useState(false);
  const [isDropOffLocation, setIsDropOffLocation] = useState(false);
  const [pickupLatLng, setPickupLatLng] = useState();
  const [dropLatLng, setDropLatLng] = useState();
  const [selectedProduct, setSelectedProduct] = useState({});

  //SLIDER SETTING SLICK
  const [settingsForSlick, setSettingsForSlick] = useState({
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 10,
    slidesToScroll: 3,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });

  //Functions (Setters)
  const storeSelectedProduct = (product) => {
    setSelectedProduct(product);
  };
  const storePickLatLng = (latlng) => {
    setPickupLatLng(latlng);
  };
  const storeDropLatLng = (latlng) => {
    setDropLatLng(latlng);
  };
  const storeSeletedVehicle = (value) => {
    setSelectedVehicle(value);
  };
  const storeCurrentAddress = (value) => {
    setCurrentAddress(value);
  };
  const storeCurrentRegion = (value) => {
    setCurrentRegion(value);
  };
  const storeIsDropOffLocation = (value) => {
    setIsDropOffLocation(value);
  };
  const storeIsPickupLocation = (value) => {
    setIsPickupLocation(value);
  };

  return (
    <AppContext.Provider
      value={{
        baseUrl,
        apiKey,
        mobiles,
        whyChooseUs,
        selectedVehicle,
        isPickupLocation,
        isDropOffLocation,
        currentAddress,
        currentRegion,
        pickupLatLng,
        dropLatLng,
        isDesktopOrLaptop,
        repairingTypes,
        settingsForSlick,
        selectedProduct,
        //FUNCTION BELOW
        navigate,
        storeSelectedProduct,
        storePickLatLng,
        storeDropLatLng,
        storeCurrentAddress,
        storeCurrentRegion,
        storeSeletedVehicle,
        storeIsPickupLocation,
        storeIsDropOffLocation,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
export default AppContext;
